import React from "react";
import classes from "./RectangleCard.module.scss";
import classnames from "classnames";
import { RectangleCardProps } from "components/v2/Cards/RectangleCard/types/RectangleCardProps";

const RectangleCard: React.FC<RectangleCardProps> = (rectangleCardProps) => {
  return (
    <div
      className={
        rectangleCardProps.darker
          ? classnames(
              classes["rectangle-card-secondary-dark"],
              rectangleCardProps.additionalClassNames,
            )
          : rectangleCardProps.lighter
          ? classnames(
              classes["rectangle-card-light"],
              rectangleCardProps.additionalClassNames,
            )
          : rectangleCardProps.medium
          ? classnames(
              classes["rectangle-card-light-secondary"],
              rectangleCardProps.additionalClassNames,
            )
          : classnames(
              classes["rectangle-card"],
              rectangleCardProps.additionalClassNames,
            )
      }
      onClick={rectangleCardProps.onClick}
    >
      {rectangleCardProps.children}
    </div>
  );
};
export default RectangleCard;
